export default __webpack_public_path__ + "static/media/heart-header.5d7d6856.svg";